import { render, staticRenderFns } from "./CustomPromotionSpace.vue?vue&type=template&id=2d5c594e&scoped=true&"
import script from "./CustomPromotionSpace.vue?vue&type=script&lang=js&"
export * from "./CustomPromotionSpace.vue?vue&type=script&lang=js&"
import style0 from "./CustomPromotionSpace.vue?vue&type=style&index=0&id=2d5c594e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c594e",
  null
  
)

export default component.exports